import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
} from '@mui/material';
import { useFormikContext } from 'formik';
import { industries, Industry as IIndustry } from '@/constants/industries';

const Industry = () => {
  const { values, handleChange } = useFormikContext<{ industry: string }>();

  return (
    <Stack spacing={2} flex={1}>
      <FormControl fullWidth>
        <InputLabel id="industry-id">Industria</InputLabel>
        <Select
          labelId="industry-id"
          label="Industria"
          size="small"
          name="industry"
          value={values.industry}
          onChange={handleChange}
        >
          {Object.values(industries).map((industry: IIndustry) => (
            <MenuItem key={industry.id} value={industry.id}>
              {industry.locale.es}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Stack>
  );
};

export default Industry;
